import React, { useMemo, useState } from "react";
import { Alert, Box, Button, Paper, Stack, TextField, Typography } from "@mui/material";
import { Link, useHistory, useLocation } from "react-router-dom";

import { resetNetworkPortalPassword } from "../../services/coreNetworkPortal";

export default function TalentResetPassword() {
  const history = useHistory();
  const location = useLocation();
  const token = useMemo(() => new URLSearchParams(location.search).get("token") || "", [location.search]);
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  async function handleSubmit(event) {
    event.preventDefault();
    try {
      setLoading(true);
      setError("");
      const response = await resetNetworkPortalPassword(token, password);
      setMessage(response?.message || "Password updated successfully.");
      setTimeout(() => history.replace("/talent/login"), 1200);
    } catch (resetError) {
      setError(resetError?.response?.data?.message || resetError.message || "Unable to reset password.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <Box sx={{ minHeight: "100vh", display: "grid", placeItems: "center", background: "linear-gradient(180deg, #f7fafc 0%, #edf2f7 100%)", px: 2 }}>
      <Paper elevation={0} sx={{ width: "100%", maxWidth: 460, p: 4, borderRadius: 4, border: "1px solid #d9e2ec" }}>
        <Stack spacing={3} component="form" onSubmit={handleSubmit}>
          <Typography variant="h4" sx={{ fontWeight: 700 }}>Reset Password</Typography>
          {!token ? <Alert severity="error">Missing reset token.</Alert> : null}
          {message ? <Alert severity="success">{message}</Alert> : null}
          {error ? <Alert severity="error">{error}</Alert> : null}
          <TextField label="New Password" type="password" value={password} onChange={(event) => setPassword(event.target.value)} required fullWidth />
          <Button type="submit" variant="contained" disabled={loading || !token}>
            {loading ? "Updating..." : "Update Password"}
          </Button>
          <Button component={Link} to="/talent/login" size="small">Back to login</Button>
        </Stack>
      </Paper>
    </Box>
  );
}
